module.exports = __webpack_public_path__ + "static/img/9.0b2dd09a.gif";